import * as React from 'react';
import { SxProps, Table, TableContainer, Theme } from '@mui/material';

export const TableContentWrapper: React.FC<{
    children: React.ReactNode;
    wrapperStyles?: SxProps<Theme>;
    wrapperRef?: React.Ref<HTMLDivElement>;
    onWrapperScroll?: React.UIEventHandler<HTMLDivElement>;
}> = (props) => {
    return (
        <TableContainer
            ref={props.wrapperRef}
            onScroll={props.onWrapperScroll}
            sx={props.wrapperStyles}
        >
            <Table
                sx={{ minWidth: 650 }}
                aria-labelledby="tableTitle"
                size={'medium'}
            >
                {props.children}
            </Table>
        </TableContainer>
    );
};
